import App from 'app/app.js';
import 'app/service/EventService.js';

function LoginSuccessAction(EventService) {
  this.eventName = 'login-success';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('LoginSuccessAction', ['EventService', LoginSuccessAction]);
